import styled from "styled-components";

export const PageDishesWrapper = styled.div`
  .details {
    margin: 70px 0px 0px 45px;
  }

  .buttons-aligned {
  display: flex;
  align-items: center;
  padding: 10px;
  justify-content: center;
  width: 100%;
}

  .paginate-current {
    background: var(--paginateCurrent);
    transition: var(--mainTransition);
  }

  h6 > a {
    color: var(--productListBtnHighlight);
    font-weight: bold;
    text-decoration: none;
    font-size: 14px;
  }

  .big-img {
    width: 335px;
    height: 285px;
    object-fit: cover;
    margin-top: 80px;
  }

  .small-img {
    width: 100px;
    height: 93px;
    object-fit: cover;
  }



  @media only screen and (min-width: 1024px) and (min-height: 1366px) {
    .extra-devices {
      margin-left: 20px;
    }

    .div-control .medium-img {
      object-fit: cover;
      padding: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    .content-inside .div-control {
      margin: 0;
      padding: 5px;
    }

    .div-control .big-img {
      width: 100%;
    }
    .details {
      margin: 70px 0px 0px 0px;
    }
  }
  }
`;
